import { navCopy as enNavCopy } from "../en/nav"

export const navCopy = {
  ...enNavCopy,
  skip_to_content: "Pular para o conteúdo principal",
  nav_documentation: "Documentação",
  nav_documentation_short: "Documentos",
  nav_download: "Download",
  nav_connect: "Conectar",
  nav_playground: "Parque infantil",
  nav_search_placeholder: "Documentos de pesquisa",
  nav_search_aria: "Pesquise no site TypeScript",
  nav_beta: "Pesquise no site TypeScript",
  nav_beta_notification:
    "Nota: esta página é uma página beta, não confie nos problemas de URL e de arquivos <a>no microsoft/TypeScript-Website</a>",
}
